import React, { Component } from "react";
import { Table, Button, Input, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import CheckListOSForm from '../components/CheckListOSForm';
import { getTemPermissao } from "../utils/LoginManager";

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    buscaOrdem: { campo: 'clos_descricao', ordem: 'ASC' },
  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/checklist', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.clos_idf) {
      request = axios.put(`/checklist/update/${registro.clos_idf}`, registro);
    } else {
      request = axios.post(`/checklist/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar.', okText: 'OK', })
      })
  }


  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/checklist/show/${registro.clos_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.tipoItem = 'P';
        data.dados.closi_produto = { key: '0' };
        data.dados.closi_servico = { key: '0' };
        data.dados.closi_avulso = '';
        data.dados.closi_valor = 0;

        let listaItens = [];
        for (var x in data.listaItens) {
          listaItens.push({
            closi_seq: data.listaItens[x].closi_seq,
            closi_produto: data.listaItens[x].closi_produto,
            closi_servico: data.listaItens[x].closi_servico,
            closi_avulso: data.listaItens[x].closi_avulso,
            closi_valor: data.listaItens[x].closi_produto ? data.listaItens[x].prod_vlr_venda : data.listaItens[x].closi_servico ? data.listaItens[x].serv_valor : data.listaItens[x].closi_valor,
            tipoItem: data.listaItens[x].closi_produto ? 'P' : data.listaItens[x].closi_servico ? 'S' : 'A',
            codItem: data.listaItens[x].closi_produto ? data.listaItens[x].prod_codigo : '',
            descItem: data.listaItens[x].closi_produto ? data.listaItens[x].prod_descricao : data.listaItens[x].closi_servico ? data.listaItens[x].serv_descricao : data.listaItens[x].closi_avulso,
          });
        };

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            data: data.dados,
            listaItens,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/checklist/delete/${registro.clos_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.clos_idf === registro.clos_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        listaItens: [],
        data: {
          clos_codigo: 0,
          tipoItem: 'P',
          closi_produto: { key: '0' },
          closi_servico: { key: '0' },
          closi_avulso: '',
          closi_valor: 0,
        },
        visualizar: false,
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }





  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('CheckListOSPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('CheckListOSPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    return (
      <div className="contentRoutesContainer">
        <div>
          <span className="tituloPage">Cadastro de CheckList OS</span>
          <div className="divider-page1" />

          <div className="pageFiltro">
            {getTemPermissao('CheckListOSPage', 'novo') ? (
              <Button
                type="primary"
                onClick={this.onAdicionarClick}
                className="botao-primary"
              >
                Adicionar
              </Button>
            ) : null}

            <Search
              placeholder="Buscar por Descrição"
              onSearch={this.onBuscar}
              enterButton
              className="pageFiltro-busca"
            />

            <CheckListOSForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

          </div>

          <br />

          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.clos_idf)}
          >
            <Column
              key="clos_descricao"
              dataIndex="clos_descricao"
              title={this.renderTitulo("Descrição")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={400}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={70}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CheckListOSPage.js